import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

export const appRoutes: Route[] = [

    {path: '', pathMatch : 'full', redirectTo: 'sign-in'},


    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'trailer-systems/list'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            //{path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password/:token', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)}
        ]
    },

    // Maintenance route
    {
        path: '',
        component  : LayoutComponent,
        data: {
            layout: 'empty'
        },
        children   : [
            {path: 'maintenance', loadChildren: () => import('app/modules/pages/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule)},
        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        data: {
            layout: 'material'
        },
        children   : [

            // Dashboards
            {path: 'trailer-systems', children: [
                {path: 'list', loadChildren: () => import('app/modules/pages/trailer-systems/list/list.module').then(m => m.ListModule)},
                {path: 'map', loadChildren: () => import('app/modules/pages/trailer-systems/map/map.module').then(m => m.MapModule)},
                {path: 'overview', loadChildren: () => import('app/modules/pages/trailer-systems/overview/system-overview.module').then(m => m.OverviewModule)}
            ]},

            {path: 'user-management', loadChildren: () => import('app/modules/pages/user-management/user-management.module').then(m => m.UserManagementModule)},
            {path: 'system-assignment', loadChildren: () => import('app/modules/pages/system-assignment/system-assignment.module').then(m => m.SystemAssignmentModule)},
            {path: 'notifications', loadChildren: () => import('app/modules/pages/notifications/notifications.module').then(m => m.NotificationsModule)},
            {path: 'bulletin-management', loadChildren: () => import('app/modules/pages/bulletin-management/bulletin-management.module').then( m => m.BulletinManagementModule)},


            // 404 & Catch all
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/pages/pages/error/error-404/error-404.module').then(m => m.Error404Module)},
            {path: '**', redirectTo: '404-not-found'}
        ]
    }
];
